<div class="p-3 mt-1">
  <div class="">
    <div class="container flex-grow-1 flex flex-wrap">
      <div class="left-box">
        <div class="leg-type-label mb-2">Pick-up</div>
        <table>
          <tr>
            <td style="width: 20px; vertical-align: top">
              <i class="fa fa-map-marker"></i>
            </td>
            <td>
              <vehicle-address [vehicleAddress]="task.pickupLocation"></vehicle-address>
            </td>
          </tr>
        </table>
      </div>

      <div class="right-box">
        <div class="w-full">
          <task-supplier-schedule-step
            [supplierScheduleStore]="supplierScheduleStore"
            [source]="source"
            [task]="task"
          ></task-supplier-schedule-step>
        </div>

        <div class="w-full">
          <div class="mt-2"><b>Select your transport mode to pick-up location:</b></div>
          <div class="mt-2">
            <div
              *ngFor="let transportMode of transportModes"
              class="transport-ball"
              (click)="setTransportMode(transportMode.value)"
              [class.selected]="taskSupplierScheduleStore.travelMode == transportMode.value"
            >
              <i class="la {{ transportMode.icon }}"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container flex-grow-1 flex flex-wrap mt-3">
      <div class="left-box">
        <span class="leg-type-label mb-2">Drop-off</span>
        <table>
          <tr>
            <td style="width: 20px; vertical-align: top">
              <i class="fa fa-map-marker"></i>
            </td>
            <td>
              <vehicle-address [vehicleAddress]="task.dropoffLocation"></vehicle-address>
            </td>
          </tr>
        </table>
      </div>

      <div class="right-box">
        <div class="w-full">
          <task-supplier-schedule-step
            [supplierScheduleStore]="supplierScheduleStore"
            [source]="source"
            [task]="task"
            [isDropOff]="true"
          ></task-supplier-schedule-step>
        </div>
      </div>
    </div>

    <div class="mt-2"></div>
  </div>
</div>
